import i18n from 'src/typescript/servicos/i18n/i18n.servico'

export const OPCOES_DE_APONTAMENTOS = [
  {id: 'horas_extras', name: i18n.t('hourBankRules.details.state.LimiteDeAcumuloPorHorasTrabalhadas.opcoesApontamentos.horasExtras')},
  {id: 'horas_extras_extraordinarias', name: i18n.t('hourBankRules.details.state.LimiteDeAcumuloPorHorasTrabalhadas.opcoesApontamentos.horasExtrasExtraordinarias')},
  {id: 'horas_extras_especial', name: i18n.t('hourBankRules.details.state.LimiteDeAcumuloPorHorasTrabalhadas.opcoesApontamentos.horasExtrasEspeciais')}
]

export const VALOR_PADRAO_LIMITE_HORAS_TRABALHADAS = null
export const VALOR_PADRAO_JORNADA_BASE = null

export function formatarApontamentosParaLimitePorHorasTrabalhadas (limiteDeAcumuloPorHorasTrabalhadas) {
  return limiteDeAcumuloPorHorasTrabalhadas.seletor.selected.map(apontamento => apontamento.id)
}

export function formatarValorParaLimitePorHorasTrabalhadas (limiteDeAcumuloPorHorasTrabalhadas) {
  if (!limiteDeAcumuloPorHorasTrabalhadas.valor) {
    return VALOR_PADRAO_LIMITE_HORAS_TRABALHADAS
  }

  return limiteDeAcumuloPorHorasTrabalhadas.valor
}

export function formatarJornadaBaseParaLimitePorHorasTrabalhadas (limiteDeAcumuloPorHorasTrabalhadas) {
  if (!limiteDeAcumuloPorHorasTrabalhadas.jornadaBase) {
    return null
  }

  return limiteDeAcumuloPorHorasTrabalhadas.jornadaBase
}

export function obterApontamentosSelecionadosLimiteHorasTrabalhadas (apontamentos) {
  if (!apontamentos) {
    return []
  }

  return OPCOES_DE_APONTAMENTOS.filter(opcao => {
    return apontamentos.includes(opcao.id)
  })
}

export function obterValorLimiteHorasTrabalhadas (valor) {
  if (!valor) {
    return VALOR_PADRAO_LIMITE_HORAS_TRABALHADAS
  }

  return valor
}

export function obterJornadaBaseLimiteHorasTrabalhadas (valor) {
  if (!valor) {
    return null
  }

  return valor
}
